import type { RUserProfile } from 'v2/types/api/settings'
import { canEmbedSessionTestAgent, type REmbedSession } from './embed-session'

/** What PubNubProvider connects with. Pure, so both modes test without mounting it. */
export interface PubnubIdentity {
  authed: boolean
  publishKey?: string
  subscribeKey?: string
  // Must equal the token's authorized uuid, or PubNub refuses the client.
  userId: string
  tokenKey: string
  channels: string[]
}

export const consolePubnubIdentity = (
  profile: RUserProfile | undefined,
  userAuthenticated: boolean,
): PubnubIdentity => {
  const { publish_key: publishKey, subscribe_key: subscribeKey } =
    profile?.organizations[0].pubnub_keyset_data || {}
  const aomId = profile?.organizations[0].id
  const channels = [`aom.${aomId}`]
  const orgId = profile?.organizations[0].org_id
  if (orgId) channels.push(`org.${orgId}`)
  return {
    authed: userAuthenticated,
    publishKey,
    subscribeKey,
    userId: aomId || '',
    tokenKey: aomId || '',
    channels,
  }
}

/**
 * Embed has no login or profile, so everything comes from the session that the
 * session/me probe fills. hodor mints the token for the session's ORG uuid, and
 * runs are announced on the actor's `aom.<aom_uuid>`, the only channel it grants.
 * Realtime serves only the Test agent, so only a session allowed to run it
 * connects. Keyed by session because the grant is scoped to it.
 */
export const embedPubnubIdentity = (session: REmbedSession | null): PubnubIdentity => {
  const orgUuid = session?.org_uuid ?? ''
  const aomUuid = session?.aom_uuid
  const publishKey = session?.pubnub_publish_key
  const subscribeKey = session?.pubnub_subscribe_key
  return {
    authed: Boolean(
      canEmbedSessionTestAgent(session) && orgUuid && aomUuid && publishKey && subscribeKey,
    ),
    publishKey,
    subscribeKey,
    userId: orgUuid,
    tokenKey: session?.session_id ?? '',
    channels: aomUuid ? [`aom.${aomUuid}`] : [],
  }
}
